import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import config from '../config';

const BookingVerificationPage = () => {
  const { bookingCode, userId } = useParams();
  const [status, setStatus] = useState('loading'); // loading | valid | invalid
  const [booking, setBooking] = useState(null);
  const [bookingDetails, setBookingDetails] = useState(null);
  const [bookingCodeConfirmed, setBookingCodeConfirmed] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    const checkBooking = async () => {
      try {
        const res = await fetch(config.getApiUrl(`bikes/check-booking/${bookingCode}/${userId}`));
        const data = await res.json();

        if (res.ok && data.success) {
          setBooking(data.booking);
          setStatus('valid');
          setBookingCodeConfirmed(true);
          setBookingDetails(data.booking);
        } else {
          setStatus('invalid');
        }
      } catch (err) {
        setStatus('invalid');
      }
    };

    checkBooking();
  }, [bookingCode, userId]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-gray-50 text-center">
      <img src="/logo-pointer-transparent.png" alt="Logo" className="h-16 mb-6" />
  
      {status === 'loading' && (
        <p className="text-gray-500">{t('payment.waitingForConfirmation', 'Checking booking code...')}</p>
      )}
  
      {status === 'valid' && booking && (
        <div className="bg-white p-6 rounded-xl shadow text-green-700 w-full max-w-md space-y-2 mx-auto">
            <h1 className="text-2xl font-bold mb-4 text-center">
            ✅ {t('payment.bookingConfirmed', 'Booking Confirmed')}
            </h1>
            <div className="text-left text-gray-800 space-y-1">
            <p>
                <strong>{t('bike.bike', 'Bike')}:</strong>{' '}
                {(booking.bikeModel || '–') + (booking.bikeId ? ` (${booking.bikeId})` : '')}
            </p>
            <p>
                <strong>{t('checkout.date', 'Date')}:</strong> {booking.bookingDate || '–'}
            </p>
            <p>
                <strong>{t('checkout.time', 'Start Time')}:</strong> {booking.startTime || '–'}
            </p>
            <p>
                <strong>{t('checkout.duration', 'Duration')}:</strong>{' '}
                {t(`bike.duration.${booking.duration}`, booking.duration || '–')}
            </p>
            </div>
        </div>
      )}
    
      {status === 'invalid' && (
        <div className="bg-white p-6 rounded-xl shadow text-red-600 w-full max-w-md">
          <h1 className="text-2xl font-bold mb-2">❌ {t('payment.bookingNotFound', 'Booking Not Found')}</h1>
          <p>{t('payment.contactSupport', 'Please check the QR code or contact support.')}</p>
        </div>
      )}
    </div>
  );  
};

export default BookingVerificationPage;
